import { Component } from '@angular/core';

@Component({
    selector: 'app-page-new-proforma',
    templateUrl: './page-new-proforma.component.html',
    styleUrls: ['./page-new-proforma.component.css'],
    standalone: false
})
export class PageNewProformaComponent {

}
